import { render, staticRenderFns } from "./deliverynoteviewer.vue?vue&type=template&id=5d2c8d46&scoped=true&"
import script from "./deliverynoteviewer.vue?vue&type=script&lang=js&"
export * from "./deliverynoteviewer.vue?vue&type=script&lang=js&"
import style0 from "./deliverynoteviewer.vue?vue&type=style&index=0&id=5d2c8d46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2c8d46",
  null
  
)

export default component.exports